import { render, staticRenderFns } from "./BioVision.vue?vue&type=template&id=a3877d60&scoped=true&"
import script from "./BioVision.vue?vue&type=script&lang=js&"
export * from "./BioVision.vue?vue&type=script&lang=js&"
import style0 from "./BioVision.vue?vue&type=style&index=0&id=a3877d60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3877d60",
  null
  
)

export default component.exports